import { vp_mousedclick, vp_mousedown, vp_mousemove, vp_mouseup } from 'uScope/js/hmi/pointerApi';
import app from '../../public-api';

app.plugins.register({
  name: 'us:hmi:touch',

  extends: 'viewport',

  constructor (uScope, viewport) {
    viewport.events.on('viewport:bind-events', () => {
      const $divViewport = viewport.vpDivGet()[0];
      bind($divViewport, 'touchstart', touchStart.bind(null, uScope, viewport));
      bind($divViewport, 'touchmove', touchMove.bind(null, uScope, viewport));
      bind($divViewport, 'touchend', touchEnd.bind(null, uScope, viewport));
    });
  }
});

function bind (el, event, delegate) {
  el.addEventListener(event, delegate, {passive: false});
}

let lastTouchTime = 0;
let lastTouchStartEvent;

// Converts touch start to either mousedown or doubleclick event
function touchStart (uScope, viewport, e) {
  stopTheBrowserfromScalingTheWindow(e);

  if (e.touches.length === 1) {
    lastTouchStartEvent = e;

    const now = Date.now();
    lastTouchTime = lastTouchTime || now + 1;
    const delta = now - lastTouchTime;
    lastTouchTime = now;

    if (delta < 300 && delta > 0) {
      viewport.navModeHalt();
      return vp_mousedclick(uScope, viewport, lastTouchStartEvent);
    }
  }

  return vp_mousedown(uScope, viewport, e);
}

function touchMove (uScope, viewport, e) {
  stopTheBrowserfromScalingTheWindow(e);
  vp_mousemove(uScope, viewport, e);
}

function touchEnd (uScope, viewport, e) {
  stopTheBrowserfromScalingTheWindow(e);
  vp_mouseup(uScope, viewport, e);
}

function stopTheBrowserfromScalingTheWindow (e) {
  if (e.touches && e.touches.length === 2) {
    e.preventDefault();
  }
}



// WEBPACK FOOTER //
// ./src/uScope/js/hmi/touch/touch-loader.js